/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import type { JobBoardProvider } from '../types';

interface EmptyStateProps {
	provider: JobBoardProvider;
}

export default function EmptyState( { provider }: EmptyStateProps ) {
	return (
		<div className="job-board__empty">
			<p className="job-board__empty-message">{ __( 'There are currently no open positions. Please check back later.', 'pca' ) }</p>
		</div>
	);
}
